import React, {useState} from 'react';
import {ErrorMessage} from 'formik';
import {Button, Col, Input, Modal, Typography} from 'antd';
import {dateConversionIsoToLocal} from 'Utils/helpers/DateValidation';
import {FORMAT_TYPE} from 'Utils/constants/DateFormat';
import {useSelector} from 'react-redux';
import {fieldColProps, labelStyle} from '../gridHelpers';

const CommentBox = (props) => {
  const {formikProp} = props;
  const textField = props.field;
  const [openCommentDialog, isOpenCommentDialog] = useState(false);
  const [commentText, setCommentText] = useState('');
  const userName = useSelector((state: any) => state?.login?.userName);

  const handleSubmit = () => {
    const timeStamp = dateConversionIsoToLocal(new Date(), FORMAT_TYPE?.DATE_TIME);
    let existingComment = formikProp.values[textField?.name] ?? '';
    if (commentText !== '') {
      let comments = '';
      const audit = ` \n\n- ${userName} ${timeStamp}`;
      if (existingComment) {
        comments = `${commentText}${textField?.disableAudit ? '' : audit}\n\n${existingComment}`;
      } else {
        comments = `${commentText}${textField?.disableAudit ? '' : audit}`;
      }
      formikProp.setFieldValue(textField?.name, comments);
      hadleModal();
    }
  };

  const hadleModal = () => {
    setCommentText('');
    isOpenCommentDialog(!openCommentDialog);
  };

  return (
    <>
      <Col {...fieldColProps(textField)}>
        <Typography.Text style={labelStyle}>{textField.fieldLabel}</Typography.Text>
        <Input.TextArea
          disabled={textField.isDisabled ?? false}
          readOnly
          rows={textField.rows}
          name={textField.name}
          value={formikProp.values[textField.name] ?? ''}
          onClick={hadleModal}
        />
        {textField.note && <Typography.Text type="secondary">{textField.note}</Typography.Text>}
        <ErrorMessage name={textField.name} component="div" />
      </Col>
      <Modal
        open={openCommentDialog}
        onCancel={() => isOpenCommentDialog(false)}
        title="Note"
        width={640}
        footer={[
          <Button key="cancel" danger onClick={hadleModal}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleSubmit}>
            Submit
          </Button>,
        ]}>
        <div style={{padding: 20}}>Escape = Discard changes made and exit.</div>
        <Input.TextArea
          placeholder="Comments"
          rows={12}
          autoFocus
          style={{marginBottom: 20}}
          onChange={(e) => setCommentText(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default CommentBox;
